import { useState } from 'react';
import styled from 'styled-components';

// Deliberately not a theme color — the banner must look foreign to the app so
// preview environments are unmistakable at a glance.
const BANNER_BLUE = '#1D4ED8';
const BANNER_HEIGHT = 28;

// Only pv.dev preview builds carry this flag — the preview server
// (opp-demo-builder) writes it into every generated frontend env. Everything
// else — prod, dev, stage, local, Firebase demo channels — renders nothing.
const isPreview = import.meta.env.REACT_APP_ENVIRONMENT === 'preview';

const SBanner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: ${BANNER_HEIGHT}px;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${BANNER_BLUE};
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const SDismiss = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  padding: 0 12px;
  border: none;
  background: none;
  color: #ffffff;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
`;

const EnvironmentBanner = () => {
  // Dismissal is deliberately not persisted — the banner must reassert itself
  // on every fresh page load so previews stay unmistakable.
  const [dismissed, setDismissed] = useState(false);

  if (!isPreview || dismissed) {
    return null;
  }

  return (
    <SBanner>
      Preview environment — not production
      <SDismiss aria-label='Dismiss banner' onClick={() => setDismissed(true)}>
        ✕
      </SDismiss>
    </SBanner>
  );
};

export default EnvironmentBanner;
